import {
  persistLastDwelling,
  getPersistedLastDwelling
} from '../helpers/persistence';

import { CROSS_DOMAIN_NAVIGATION } from './app';
import { LOGOUT } from './auth';
import shallowEqual from '../../utils/shallow-equal';

const LOAD = 'detail/LOAD';
const LOAD_SUCCESS = 'detail/LOAD_SUCCESS';
const LOAD_FAIL = 'detail/LOAD_FAIL';
const GET_CONTACT_DETAIL = 'dwelling/GET_CONTACT_DETAIL';
export const GET_CONTACT_DETAIL_SUCCESS = 'dwelling/GET_CONTACT_DETAIL_SUCCESS';
const GET_CONTACT_DETAIL_FAIL = 'dwelling/GET_CONTACT_DETAIL_FAIL';
const SET_LAST_DWELLING = 'dwelling/SET_LAST_DWELLING';

const API_ENDPOINT = '/api/dwellings';

const persistedLastDwelling = getPersistedLastDwelling();

function parseLastDwelling(payload = {}) {
  return {
    dwellingId: payload.dwellingId || null,
    headline: payload.headline || '',
    image:
      payload.image || (payload.images && payload.images.length) ? true : false,
    images: payload.images || [],
    subscribed: payload.subscribed || false
  };
}

const defaultState = {
  lastDwelling: null,
  detail: null,
  contact: null,
  statusCode: null
};

const initialState = persistedLastDwelling
  ? {
      ...defaultState,
      lastDwelling: parseLastDwelling(persistedLastDwelling)
    }
  : defaultState;

export default function dwelling(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return {
        ...defaultState,
        lastDwelling: state.lastDwelling
      };
    case LOAD_SUCCESS: {
      let lastDwelling = defaultState.lastDwelling;
      if (
        !action.subscriber &&
        !(
          state.lastDwelling &&
          state.lastDwelling.subscribed &&
          state.lastDwelling.dwellingId === action.payload.dwellingId
        )
      ) {
        lastDwelling = parseLastDwelling(action.payload);
        persistLastDwelling(lastDwelling);
      }

      return {
        ...state,
        lastDwelling,
        detail: action.payload
      };
    }
    case GET_CONTACT_DETAIL_SUCCESS:
      return {
        ...state,
        contact: action.payload
      };

    case LOAD_FAIL:
      return {
        ...state,
        statusCode: action.error.statusCode
      };
    case CROSS_DOMAIN_NAVIGATION:
      if (state.lastDwelling) {
        persistLastDwelling(state.lastDwelling);
      }
      return state;
    case LOGOUT:
      return {
        ...state,
        contact: null
      };
    case SET_LAST_DWELLING: {
      const lastDwelling = parseLastDwelling(
        action.payload || persistedLastDwelling
      );
      persistLastDwelling(lastDwelling);

      return {
        ...state,
        lastDwelling
      };
    }
    default:
      return state;
  }
}

export function dwellingIsLoaded(globalState, id) {
  const detail = globalState.dwelling.detail;
  return id ? detail && detail.dwellingId === id : detail;
}

export function getDwelling(id, payload) {
  return {
    ...payload,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${API_ENDPOINT}/${id}`)
  };
}

export function getContact(id) {
  return {
    types: [
      GET_CONTACT_DETAIL,
      GET_CONTACT_DETAIL_SUCCESS,
      GET_CONTACT_DETAIL_FAIL
    ],
    promise: client => client.get(`${API_ENDPOINT}/${id}/agent`),
    throwError: true
  };
}

export function setLastDwelling(payload) {
  return { type: SET_LAST_DWELLING, payload };
}

export function serialize(state) {
  if (shallowEqual(state, defaultState)) {
    return null;
  }
  return state;
}

export function deserialize(state) {
  if (state === null) {
    return initialState;
  }
  return state;
}
